import { FC as ReactFC } from 'react';

import * as intl from 'react-intl-universal';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Col, ModalBody, ModalHeader, Row } from 'reactstrap';

import ModulePaths from 'constants/ModulePaths';
import InsLink from 'shared/components/ins-link/InsLink';
import successAnimation from 'shared/static/img/animations/success.gif';

import styles from './verifyAccountSuccess.module.scss';

const VerifyAccountSuccess: ReactFC<RouteComponentProps> = () => (
  <>
    <ModalHeader className="increase-font text-center">
      {intl.get('LBL_CA_EMAIL_CONFIRMED_TITLE')}
      <br />
      {intl.get('LBL_CA_CREATED_ACCOUNT_SUCCESS')}
    </ModalHeader>
    <ModalBody>
      <Row>
        <Col
          xs="12"
          className="d-flex justify-content-center mb-3 px-3 pb-3 pt-1"
        >
          <img src={successAnimation} alt="Success" className={styles.anim} />
        </Col>
      </Row>
      <Row className="justify-content-center mt-3 mb-3">
        <Col xs="auto">
          <InsLink
            to={`${ModulePaths.DashboardPath}${ModulePaths.DashboardGettingStartedPath}`}
            className="btn btn-primary"
          >
            {intl.get('BTN_CA_LETS_GET_STARTED')}
          </InsLink>
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="text-center pt-3 mt-3">
          <small>
            {intl.get('LBL_CA_NEED_ASSISTANCE')}{' '}
            <a
              href="https://support.dreamstartlabs.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              {intl.get('LBL_CA_CONTACT_SUPPORT')}
            </a>
          </small>
        </Col>
      </Row>
    </ModalBody>
  </>
);

export default withRouter(VerifyAccountSuccess);
